import { Container, Tooltip } from "@chakra-ui/react";
import { IoSettingsSharp, IoStatsChart } from "react-icons/io5";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export default function DashboardHeader({
  activeTab,
  setActiveTab,
  t,
  notAllowedToNavigateTabs,
  navigateToProjectStatistics,
  navigateToProjectDeploy,
}) {
  const deployedClass = notAllowedToNavigateTabs
    ? "cursor-not-allowed"
    : "cursor-pointer";
  return (
    <Container
      className='flex justify-around text-xl w-4/5 mx-auto'
      fontSize={{ base: "2xl", lg: "3xl" }}
    >
      <div className='flex items-center w-full'>
        {[
          { id: 0, label: t("userDashboard.building") },
          { id: 1, label: t("userDashboard.rules") },
          { id: 2, label: t("userDashboard.design") },
          { id: 4, label: t("userDashboard.deploy") },
        ].map((step, index, array) => {
          const isClickable = true; // step.id === activeTab + 1 || step.id === 4;
          const isPrevious = activeTab > step.id;
          return (
            <div key={step.id} className='flex items-center flex-1'>
              <div className='flex items-center justify-center flex-1'>
                <div className='flex flex-col items-center'>
                  <Tooltip
                    isDisabled={isClickable || step.id === 4}
                    label={t("projectDeploy.alertText")}
                  >
                    <div
                      onClick={() => {
                        if (step.id === 4) {
                          navigateToProjectDeploy();
                        } else if (isClickable && !notAllowedToNavigateTabs) {
                          setActiveTab(step.id);
                        }
                      }}
                      className={`flex flex-col items-center ${
                        (isClickable && !notAllowedToNavigateTabs) ||
                        step.id === 4
                          ? "cursor-pointer"
                          : "cursor-not-allowed"
                      } ${step.id === 4 ? "" : deployedClass}`}
                    >
                      <div
                        className={`w-8 h-8 rounded-full flex items-center justify-center mb-2 border-2 text-lg 
                        ${
                          isPrevious || activeTab === step.id
                            ? "bg-primary border-primary text-white"
                            : "border-slate-300 text-slate-400"
                        }`}
                      >
                        {isPrevious ? (
                          <IoMdCheckmarkCircleOutline className='w-6 h-6' />
                        ) : (
                          step.id + 1
                        )}
                      </div>
                      <span
                        className={`text-lg ${
                          activeTab === step.id
                            ? "text-primary font-medium underline"
                            : isPrevious
                            ? "text-primary"
                            : "text-slate-400"
                        }`}
                      >
                        {step.label}
                      </span>
                    </div>
                  </Tooltip>
                </div>
                {index < array.length - 1 && (
                  <div
                    className={`h-[2px] w-24 mb-6 mx-4 self-center ${
                      isPrevious ? "bg-primary" : "bg-slate-200"
                    }`}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className='flex items-center gap-10 mx-10 text-4xl'>
        <div
          onClick={() => navigateToProjectStatistics()}
          className={`cursor-pointer select-none  text-primary`}
        >
          <IoStatsChart />
        </div>
        <Tooltip
          isDisabled={!notAllowedToNavigateTabs}
          label={t("projectDeploy.alertText")}
        >
          <div
            onClick={() => setActiveTab(3)}
            className={`cursor-pointer select-none  text-primary`}
          >
            <IoSettingsSharp />
          </div>
        </Tooltip>
      </div>
    </Container>
  );
}
